export const TIPS_TYPES = {
    TIPS: 'TIPS',
    POST_CONNECTION: 'POST_CONNECTION',
    DEVICE_OFFLINE: 'DEVICE_OFFLINE',
    EXPERIENCE_MODE: 'EXPERIENCE_MODE',
    PHONE_OFFLINE: 'PHONE_OFFLINE',
};
